import { useState } from 'react';
import { FaqVariants } from '../../../Common/FAQS';
import { LANG_DATA } from '../language/dataset';
import { NewToCContainer } from '../styles';
import { ITOC } from '../types';
import { IndexList } from './index_list';
import { handleTrack } from '../../../../utils/tracker';

export const NewTableOfContent = ({
  language,
  tocIndexList,
  dom,
  variant = FaqVariants.default,
}: ITOC): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<string>('');

  // Always render the container with sideTOC div to keep it in DOM
  // Only skip rendering IndexList if dom is not ready
  const hasContent = dom && tocIndexList && tocIndexList.length > 0;

  return (
    <NewToCContainer
      className="text-s-12 sm:max-w-none max-w-[290px] sticky top-20"
      onClick={(e) => {
        handleTrack({
          label: 'lhs_cta',
          obj: e.target,
        });
      }}
    >
      <div id="sideTOC" className={`${variant}`}>
        <div id="TOC_side">
          <div className="tocHeading pb-2 text-base font-bold sm:hidden sticky top-0 bg-white">
            {LANG_DATA[language]?.sideBar.content}
          </div>
          <div className="TOC_index_Desktop TOC_index max-h-[475px] overflow-auto indexTOC pr-4">
            {hasContent && (
              <IndexList
                tocIndexList={tocIndexList}
                dom={dom}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
              />
            )}
          </div>
        </div>
      </div>
    </NewToCContainer>
  );
};
